import $ from 'jquery';
// Сам video.js загружается через <script> в resources/views/demo_lab/show.blade.php
//import videojs from 'video.js';
import ru from 'video.js/dist/lang/ru.json';

export default function() {
    if (typeof window.videojs === 'function') {
        videojs.addLanguage('ru', ru);
        $('.js-player').each(function () {
            videojs(this, {
                controls: true,
                preload: 'auto',
            });
        });
    }

    // responsive: false,
    //  disablePictureInPicture: true,
    //  controlBar: {
    //      pictureInPictureToggle: false // Отключает кнопку PiP
    //  },
    // fluid: true,
    // controls: true,
    // autoplay: false,
    // preload: 'auto',
    // enableSmoothSeeking: true,
    // poster: this.getAttribute('data-poster') ?? '',
}
